<template>
    <div class="profile-tabs__wrapper profile-tabs__wrapper--volunteer">

        <div class="profile-tabs">
            <div class="profile-tabs__header-text">{{$store.getters.t('user_dashboard_tabs_follows')}}</div>

            <template v-if="follows.length && loaded">
                <div class="profile-tabs__scroll-wrapper">
                    <div class="profile-tabs__body">

                        <div class="profile-tabs__body-item d-flex" v-for="({target = null, ...item}, index) in follows" :key="index">

                            <template v-if=" item && item.target_type.indexOf('Pet') >= 0 ">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/pets/${item.target_id}`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${target.avatar.path.replace('original', 'avatar')}`" :alt="target.name" v-if="target.avatar">
                                        <span v-else v-text="getUserPM(target.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/pets/${item.target_id}`" class="profile-tabs__body-name">{{ target.name }}</a>
                                    <div class="profile-tabs__body-meta">
                                        <a :href="`/user/${target.user_id}/profile`" v-if="target.user && target.user_id && target.user.name">{{target.user.name + ', '}}</a>
                                        <span v-else-if="target.user && target.user.name">{{target.user.name + ', '}}</span>
                                        <span v-if="target.city && target.city.name">{{target.city.name}}</span>
                                    </div>

                                    <span class="tabs-icon d-flex" :style="{background: '#EAF1FC'}">
                                        <img src="/assets/images/icons/heart.svg" alt="">
                                    </span>

                                </div>
                            </template>

                            <template v-if=" item && item.target_type.indexOf('Project') >= 0 ">
                                <div class="profile-tabs__body-header">
                                    <a :href="`/projects/${item.target_id}`" class="profile-tabs__body-image">
                                        <img :src="`/storage/${target.avatar.path.replace('original', 'avatar')}`" :alt="target.name" v-if="target.avatar">
                                        <span v-else v-text="getUserPM(target.name || 'Anonymous')"></span>
                                    </a>
                                </div>

                                <div class="profile-tabs__body-content">
                                    <a :href="`/projects/${item.target_id}`" class="profile-tabs__body-name">{{ target.name }}</a>
                                    <div class="profile-tabs__body-meta">
                                        <a :href="`/user/${target.user_id}/profile`" v-if="target.user && target.user_id && target.user.name">{{target.user.name + ', '}}</a>
                                        <span v-else-if="target.user && target.user.name">{{target.user.name + ', '}}</span>
                                        <span v-if="target.city && target.city.name">{{target.city.name}}</span>
                                    </div>

                                    <span class="tabs-icon d-flex" :style="{background: '#EAF1FC'}">
                                        <img src="/assets/images/icons/heart.svg" alt="">
                                    </span>

                                </div>
                            </template>

                        </div>

                    </div>
                </div>
            </template>
            <template v-else-if="!loaded">
                <div class="profile-dashboard__pets-slider profile-dashboard__pets-slider--empty d-flex">
                    <div class="LoaderBalls">
                        <div class="LoaderBalls__item"></div>
                        <div class="LoaderBalls__item"></div>
                        <div class="LoaderBalls__item"></div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="profile-tabs__body profile-tabs__body--empty d-flex">

                    {{$store.getters.t('facilities_list_empty')}}

                </div>
            </template>


        </div>

    </div>
</template>

<script>

import {mapGetters,mapActions} from 'vuex';

import Tabs from '../tabs/Tabs';
import Tab from '../tabs/Tab';

export default {
    name: "UserDashboardTabs",
    props: ['user'],
    components: {Tab, Tabs},
    data() {
        return {
            loaded: false,
        }
    },

    computed:{
        ...mapGetters({
            follows: 'getFollows',
        })
    },


    methods: {

        getUserPM(name) {
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },

    },

    watch: {
        follows() {
            setTimeout(() => {
                this.loaded = true
            }, 1000)
        }
    },


}
</script>

<style scoped>

</style>
